<template>
	<div class="containerPage">
		<Navbar :clickProps="clickProps" @clickHandle="clickHandle" />
		<div class="mainContainer">
			<!-- 问题反馈截图弹窗 -->
			<screenshotTool @captureScreen="captureScreenHandle" />
			<!-- 问题反馈弹窗 -->
			<problemFeedbackModal v-if="problemFeedbackModalShow" :propsObj="problemFeedbackModalObj"
				@sureHandle="sureHandle" @cancelHandle="cancel" />

			<app-main @click.stop="appMainHandle()" />
		</div>
		<!-- <div class="">
			<sidebar class="sidebarContainer" />
			
			<div class="mainContainer">
				<app-main />
			</div>
		</div> -->
	</div>
</template>

<script setup>
	// import Sidebar from './components/Sidebar'
	import Navbar from './components/Navbar'
	import {
		initTheme,
		setMessageQueue
	} from '@/utils/common'
	import useUserStore from '@/store/modules/user'
	import {
		AppMain
	} from './components'
	import {
		sysfeedbackmarkQueryFeedByParam,
		sysfeedbackrecordSubmitFeedback
	} from '@/api/systemNotification'

	// 主题色--默认亮色
	const theme = computed(() => {
		console.log(useUserStore().theme, 'ooo')
		return useUserStore().theme
	})

	const clickProps = ref({
		noticeDrawerShow: false, // 站内信弹窗
		settingDrawerShow: false, // 自定义配置弹窗
		isSearchShow: false // 快捷键搜索弹窗
	})

	const problemFeedbackModalShow = ref(false) // 问题反馈弹窗
	const problemFeedbackModalObj = ref({}) // 问题反馈数据

	// 鼠标点击在非nav部分 关闭nav弹窗
	function appMainHandle() {
		clickProps.value = {
			noticeDrawerShow: false,
			settingDrawerShow: false,
			isSearchShow: false
		}
		console.log(clickProps.value, 'appMainHandle')
	}

	// nav传参过来的数据
	function clickHandle(val) {
		clickProps.value = val
		console.log(clickProps.value, 'clickHandle')
	}

	// 返回截图并且上传截图后 问题反馈弹窗显示
	function captureScreenHandle(val, params) {
		console.log(val, 'captureScreenHandle')
		if (val) {
			// 查询当前路径对应的id
			getFeedbackData(val, params)
		} else {
			setMessageQueue('error', '截图失败，请重试！')
		}
	}

	// 查询当前路径对应的id
	function getFeedbackData(markImgBase64, params) {
		sysfeedbackmarkQueryFeedByParam(params).then(res => {
			if (res) {
				const data = res.data
				useUserStore().isModal = true
				problemFeedbackModalShow.value = true
				problemFeedbackModalObj.value = {
					markId: data.id,
					address: data.name,
					markImgBase64
				}
				console.log(problemFeedbackModalObj.value, 'problemFeedbackModalObj.value')
			}
		}).catch(e => {
			setMessageQueue('error', e)
			console.log(e)
		})
	}

	// 新增问题反馈--提交
	function sureHandle(params) {
		sysfeedbackrecordSubmitFeedback(params).then(res => {
			if (res) {
				cancel()
				setMessageQueue('success', '问题已提交')

				useUserStore().feedbackSubmit = 1
				setTimeout(() => {
					useUserStore().feedbackSubmit = 0
				})
			}
		}).catch(e => {
			setMessageQueue('error', e)
			console.log(e)
		})
	}

	// 问题反馈弹窗关闭
	function cancel() {
		problemFeedbackModalShow.value = false
		useUserStore().isModal = false
	}

	onMounted(() => {
		// 初始化/重新加载当前主题色
		initTheme(theme.value)
	})
</script>

<style lang="scss" scoped>

</style>